import { fmtId } from './jiraId';

interface AdminPathOptions {
  eventId?: string | null;
  categoryId?: string | null;
  vehicleId?: string | null;
}

export function getAdminPathForView(view: string, options: AdminPathOptions = {}): string {
  if (view === 'dashboard') {
    return '/';
  }

  if (view === 'calculator') {
    return '/budget-configurator';
  }

  if (view === 'budget-category' && options.categoryId) {
    return `/budget/category/${fmtId('BC', options.categoryId)}`;
  }

  if (view === 'vehicle-detail' && options.vehicleId) {
    return `/vehicle/${fmtId('VH', options.vehicleId)}`;
  }

  if (view === 'shipping') {
    return '/procurement/shipping';
  }

  if (view === 'shipping-agent-edit') {
    return '/procurement/shipping';
  }

  // Sub-tabs nested under a sidebar parent (Sidebar.tsx's nav restructure) —
  // these used to be reachable only via Header.tsx's breadcrumb dropdown,
  // not a real route a sidebar click could land on. Listed explicitly since
  // the naive `/${view}` fallback below can't turn a hyphenated composite id
  // like 'logistics-vehicles' into the real nested path '/logistics/vehicles'.
  const nestedChildRoutes: Record<string, string> = {
    'logistics-vehicles': '/logistics/vehicles',
    'logistics-drivers': '/logistics/drivers',
    'logistics-schedule': '/logistics/schedule',
    'asoebi-fabrics': '/asoebi/fabrics',
    'asoebi-orders': '/asoebi/orders',
    'asoebi-bundles': '/asoebi/bundles',
    'asoebi-assignments': '/asoebi/assignments',
    'procurement-inventory': '/procurement/inventory',
    'procurement-orders': '/procurement/orders',
    'procurement-shipments': '/procurement/shipments',
    'payments-contributors': '/payments/contributors',
    'payments-settlement': '/payments/settlement',
  };
  if (nestedChildRoutes[view]) return nestedChildRoutes[view];

  const newRoutes: Record<string, string> = {
    'task-new': '/task/new',
    'vehicle-new': '/vehicle/new',
    'stationery-item-new': '/stationery-item/new',
    'budget-category-new': '/budget-category/new',
    'catalogue-new': '/catalogue/new',
    'song-new': '/song/new',
    'driver-new': '/driver/new',
    'menu-item-new': '/menu-item/new',
  };
  if (newRoutes[view]) return newRoutes[view];

  return `/${view}`;
}